import type { DailyReportInput, DailyReportResult } from '@/types';
import { ApiError } from '@/features/bet-inspection/lib/api';

/** POST {api}/daily-reports — day-by-day bet/win/GGR for a project and window. */
export async function fetchDailyReport(params: {
  api: string;
  token: string | null;
  input: DailyReportInput;
  signal?: AbortSignal;
}): Promise<DailyReportResult> {
  const base = params.api.replace(/\/+$/, '');

  let res: Response;
  try {
    res = await fetch(`${base}/daily-reports`, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        ...(params.token ? { authorization: `Bearer ${params.token}` } : {}),
      },
      body: JSON.stringify(params.input),
      signal: params.signal,
    });
  } catch (err) {
    if ((err as Error)?.name === 'AbortError') throw err;
    throw new ApiError(`Could not reach the betlens API at ${base}.`, 0);
  }

  if (!res.ok) {
    const body = (await res.json().catch(() => null)) as { error?: string } | null;
    throw new ApiError(body?.error ?? `Request failed (${res.status})`, res.status);
  }

  return (await res.json()) as DailyReportResult;
}
